import TableAuditRenderer from './TableAuditRenderer';
import type {
  LighthouseAudit,
  LighthouseDetails
} from '@/app/PageSpeed/api/types/analysisApiTypes';

type Props = {
  audit: LighthouseAudit;
  analysisData?: LighthouseDetails;
};

const OpportunityAuditRenderer = ({ audit, analysisData }: Props) => (
  <TableAuditRenderer audit={audit} analysisData={analysisData} />
);

export default OpportunityAuditRenderer;
